export default "__VITE_ASSET__CvEtbNLv__"